import { render, staticRenderFns } from "./User-sapce-address.vue?vue&type=template&id=13d2b091&scoped=true&"
import script from "./User-sapce-address.vue?vue&type=script&lang=js&"
export * from "./User-sapce-address.vue?vue&type=script&lang=js&"
import style0 from "./User-sapce-address.vue?vue&type=style&index=0&id=13d2b091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2b091",
  null
  
)

export default component.exports